/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_EyebrowInputs */

const tr_iletisim_eyebrow = /** @type {(inputs: Iletisim_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İletişim`)
};

const en_iletisim_eyebrow = /** @type {(inputs: Iletisim_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const de_iletisim_eyebrow = /** @type {(inputs: Iletisim_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const ru_iletisim_eyebrow = /** @type {(inputs: Iletisim_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контакты`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Iletisim_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_eyebrow = /** @type {((inputs?: Iletisim_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_eyebrow(inputs)
	if (locale === "de") return de_iletisim_eyebrow(inputs)
	if (locale === "ru") return ru_iletisim_eyebrow(inputs)
	return tr_iletisim_eyebrow(inputs)
});